module.exports = __webpack_public_path__ + "assets/img/worldviewImg-861b0432.png";